(function () {
  'use strict';
  function returnToBrowsing() {
    var destination = '/';
    try {
      var saved = JSON.parse(sessionStorage.getItem('md-commerce-return'));
      var url = new URL(saved.url, location.origin);
      if (url.origin === location.origin && !/\/(cart|pages\/request-for-quote)\/?$/.test(url.pathname)) {
        destination = url.href;
        sessionStorage.setItem('md-quotify-restore', JSON.stringify(saved));
      }
    } catch (_) {}
    location.assign(destination);
  }
  try {
    var restore = JSON.parse(sessionStorage.getItem('md-quotify-restore'));
    if (restore && new URL(restore.url).pathname === location.pathname) {
      var restoreScroll = function () {
        requestAnimationFrame(function () { window.scrollTo(0, Number(restore.y) || 0); });
        sessionStorage.removeItem('md-quotify-restore');
      };
      if (document.readyState === 'complete') restoreScroll();
      else window.addEventListener('load', restoreScroll, {once:true});
    }
  } catch (_) {}
  window.addEventListener('message', function (event) {
    var frame = document.getElementById('quotify-frame');
    if (event.origin !== 'https://quotify.dev' || !frame || event.source !== frame.contentWindow) return;
    if (!event.data || event.data.type !== 'md-quotify-navigation') return;
    if (event.data.action === 'close' && landing) {
      returnToBrowsing();
    }
    if (event.data.action === 'menu') {
      var menu = document.getElementById('MobileNav_button');
      if (menu) menu.click();
    }
  });
  var landing = document.querySelector('[data-md-quote-landing]');
  if (landing) {
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-md-commerce-close]')) {
        event.preventDefault(); event.stopImmediatePropagation(); returnToBrowsing();
      }
    }, true);
    var open = landing.querySelector('[data-quotify-cart]');
    var opened = false;
    function openQuote() {
      if (document.getElementById('quotify-frame')) { opened = true; observer.disconnect(); return; }
      if (!opened && open) open.click();
    }
    var counter = document.querySelector('[data-quotify-cart-count]');
    var observer = new MutationObserver(openQuote);
    if (counter) observer.observe(counter, {childList:true,subtree:true,attributes:true});
    setTimeout(function () { observer.disconnect(); }, 30000);
    window.addEventListener('load', openQuote, {once:true});
    if (document.readyState === 'complete') openQuote();
  }
}());
